export interface Tdah3Score {
  name: string;
  score: number;
  max_score: number;
  interpretation: string;
  questions_answered: number;
}

export interface Tdah3Scores {
  control_inhibitorio: Tdah3Score;
  memoria_trabajo: Tdah3Score;
  planificacion: Tdah3Score;
  flexibilidad: Tdah3Score;
  regulacion_emocional: Tdah3Score;
  iniciativa: Tdah3Score;
}

export const TDAH3_SEVERITY_LEVELS = {
  NORMAL: {
    text: "Funcionamiento dentro de lo esperado",
    color: "text-green-600 bg-green-100 dark:bg-green-900/30",
  },
  MODERATE: {
    text: "Dificultades moderadas",
    color: "text-yellow-600 bg-yellow-100 dark:bg-yellow-900/30",
  },
  SIGNIFICANT: {
    text: "Dificultades significativas",
    color: "text-red-600 bg-red-100 dark:bg-red-900/30",
  },
};
